import {
  Menu as MuiMenu,
  MenuItem as MuiMenuItem,
  MenuProps,
  styled,
} from '@mui/material';

export const Menu = styled((props: MenuProps) => (
  <MuiMenu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))`
  & .MuiPaper-root {
    border-radius: 4px;
    min-width: 160px;
    padding: 0;
    margin-top: 8px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

    & .MuiButtonBase-root {
      & svg {
        margin-right: 10px;
      }
    }
  }
`;

export const CustomMenuItem = styled(MuiMenuItem)(
  ({ $isSelected, theme, $hasProductVariation, $destructive, disabled }) => `
  font-size: 0.875rem;
  color: ${
    disabled
      ? theme.palette.text.primary
      : $isSelected
      ? theme.palette.primary.main
      : $hasProductVariation || $destructive
      ? theme.palette.error.main
      : theme.palette.text.primary
  };
`,
);
